module.exports = __webpack_public_path__ + "static/media/avatar-ali.b6ee8a06.png";